import type { Action, StoreActionApi } from '@atlassian/react-sweet-state';
import type { AdvancedOptions, State } from '../../../../common/types';

export type UpdateAdvancedOptionsAction = (
	updatedAdvancedOptions: Partial<AdvancedOptions>,
) => Action<State, void, void>;

export const updateAdvancedOptions =
	(updatedAdvancedOptions: Partial<AdvancedOptions>) =>
	({ setState, getState }: StoreActionApi<State>) => {
		const { advancedOptions } = getState();
		setState({
			advancedOptions: { ...advancedOptions, ...updatedAdvancedOptions },
		});
	};
